import { formatDay } from '@mummssoftware/utils/formatters';
import defaults from '@mummssoftware/patient-assistance/src/translations/en.json';
import { combined, refused, total, weekdayPrefixes } from './constants';
export const makeTimeString = data => `${defaults.on} ${data.patientvisitdatetime_shifted && formatDay(data.patientvisitdatetime_shifted)}
  `;
export const makeAttributionString = data => `${data.actionbypersonfirstname || ''} ${data.actionbypersonlastname || ''} ${data.actionbypersoncredentials || ''}`;

const toWeekDay = date => new Date(date).getDay();

const parseAdmins = taskAdmins => {
  const parsed = JSON.parse(taskAdmins);
  return parsed[0] && parsed;
};

const incrementDetails = (admin, adminMap, day) => {
  switch (admin.actiontaken) {
    // braces keep count var in scope of this case
    case 'Completed':
    case 'completed':
    case 'none':
      {
        const count = adminMap[admin.actionbyperson_id][`${day}${total}`] || 0;
        adminMap[admin.actionbyperson_id][`${day}${total}`] = count + 1;
      }
      break;

    case 'Refused':
      {
        const count = adminMap[admin.actionbyperson_id][`${day}${refused}`] || 0;
        adminMap[admin.actionbyperson_id][`${day}${refused}`] = count + 1;
      }
      break;
  }

  const count = adminMap[admin.actionbyperson_id][`${day}${combined}`] || 0;
  adminMap[admin.actionbyperson_id][`${day}${combined}`] = count + 1;
};

export const makeDetailsHash = task => {
  const adminMap = {};
  const adminString = task.patientCppTaskAdministrations;
  const admins = adminString && parseAdmins(adminString);

  if (admins) {
    admins.forEach(admin => {
      const day = weekdayPrefixes[toWeekDay(admin.patientvisitdatetime_shifted)];

      if (!adminMap[admin.actionbyperson_id]) {
        adminMap[admin.actionbyperson_id] = {};
        adminMap[admin.actionbyperson_id].tasktext = `\t${makeAttributionString(admin)}`;
      }

      incrementDetails(admin, adminMap, day);
    });
  }

  return adminMap;
};